module.exports = __webpack_public_path__ + "img/paper_download.b32d40fc.svg";